import { Navigate, useLocation } from "react-router-dom";

export const OrderManagementSettingsTabRedirect = ({
  from,
  section,
  sectionByLegacyTab,
}: {
  from: string;
  section: string;
  sectionByLegacyTab?: Record<string, string>;
}) => {
  const { hash, pathname, search } = useLocation();
  if (!pathname.includes(from)) {
    return null;
  }
  const params = new URLSearchParams(search);
  const legacyTab = params.get("tab");
  params.set(
    "section",
    (legacyTab && sectionByLegacyTab?.[legacyTab]) || section,
  );
  if (sectionByLegacyTab) {
    params.delete("tab");
  }
  return (
    <Navigate
      replace
      to={`${pathname.replace(from, "/settings/order-management")}?${params.toString()}${hash}`}
    />
  );
};
